module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/048-abkhazia-3b0a5d5456e14feb84eb8a70713707a9.svg";